import { addToTag, phoneCount, sendLogList, sendMsg, tagPhoneList } from '@/server/smsSend'
import { enable } from '@/server/cs_request'
import { deleteRole } from '@/server/role_request'

/**
 * 统一 API接口平台
 */

//信息微服务
const MESSAGE = '/msg'

//用户模块微服务
const USER = '/user'

const TICKETS = '/tickets'
//短信服务
const MSG = '/sms'

// 系统模块
const SYS = '/system'
// C2C
const C2C = '/c2c'

//会话接口
export const sessionModule = {
  chatCheckApi: `${MESSAGE}/api/session/cs/sessionPageByChatRecord`,
  //查看会话列表
  querySessionListApi: `${MESSAGE}/api/session/cs/listByCs`,
  // 同事正在接待的会话（只读监看）
  listColleagueApi: `${MESSAGE}/api/session/cs/listColleague`,
  // 内部回复：同一会话里客服之间交流，玩家看不到
  sendInternalApi: `${MESSAGE}/api/msg/cs/sendInternal`,
  listInternalApi: `${MESSAGE}/api/msg/cs/listInternal`,
  joinColleagueApi: `${MESSAGE}/api/session/cs/joinColleague`,
  leaveColleagueApi: `${MESSAGE}/api/session/cs/leaveColleague`,

  //查看会话列表
  querySessionOffListApi: `${MESSAGE}/api/session/cs/listByCsOff`,
  //查看历史会话记录
  queryHistoryRecordCsApi: `${MESSAGE}/api/session/cs/getSessionChatRecord`,
  //查询会话用户信息
  querySessionUserInfoApi: `${MESSAGE}/api/session/cs/getSessionUserInfo`,
  //接入客服
  accessCustomerApi: `${MESSAGE}/api/session/admin/access/cs`,
  //转接会话
  transferCustomerApi: `${MESSAGE}/api/session/cs/transfer`,

  transferCustomerListApi: `${MESSAGE}/api/session/cs/transferList`,
  //结束会话
  finishedApi: `${MESSAGE}/api/session/cs/end`,
  //结束会话
  removeApi: `${MESSAGE}/api/session/cs/remove`,
  // F2：结束会话并让它从所有接待客服的列表里消失（同事帮忙结束时，原来的客服列表上也不再留着）
  endAndRemoveAllApi: `${MESSAGE}/api/session/cs/endAndRemoveAll`,
  //开关翻译
  translateSwitchApi: `${MESSAGE}/api/session/cs/translation/switch`,
  //开关机器人
  aiSwitchApi: `${MESSAGE}/api/session/cs/ai/switch`,
  //查看客服列表
  pageEmployeeTransferApi: `${USER}/api/employee/cs/pageWithTransfer`,
  //全部消息已读
  sessionAllReadApi: `${MESSAGE}/api/session/cs/allRead`,
  //标记为未读
  sessionUnReadApi: `${MESSAGE}/api/session/cs/unread`,
  //会话置顶
  csToTopPlaceApi: `${MESSAGE}/api/session/cs/topPlace`,
  //取消会话置顶
  csCancelTopApi: `${MESSAGE}/api/session/cs/cancelTopPlace`,
  //单个消息翻译
  translateOneApi: `${MESSAGE}/api/msg/translation/one`,
  // 消息翻译
  translateByOneIDApi: `${MESSAGE}/api/msg/translation/oneById`,
  //会话预转接
  translatePreApi: `${MESSAGE}/api/session/cs/preTransfer`,

  //消息转发
  transferMsgApi: `${MESSAGE}/api/msg/forward`,

  //开始倒计时
  startAutoEndCountdown: `${MESSAGE}/api/session/cs/startAutoEndCountdown`,
  //修改会话状态
  handleStatus: `${MESSAGE}/api/session/cs/handleStatus`,

  //发布公告
  addNoticeApi: `${MESSAGE}/api/msg/user/notice/addNotice`,

  addNotice2CsApi: `${MESSAGE}/api/msg/user/notice/addNotice2Cs`,

  //发布公告
  editNoticeApi: `${MESSAGE}/api/msg/user/notice/updateNotice`,

  //公告列表
  noticeListApi: `${MESSAGE}/api/msg/user/notice/noticeList`,
  removeEndApi: `${MESSAGE}/api/session/cs/removeAllEnd`
}

// 群聊模块（客服指定用户建群，客服不入群，仅管理/监管）
export const groupModule = {
  //建群
  createGroupApi: `${MESSAGE}/api/session/group/create`,
  //解散群
  dissolveGroupApi: `${MESSAGE}/api/session/group/dissolve`,
  //群信息（成员列表）
  groupInfoApi: `${MESSAGE}/api/session/group/info`,
  //只读监管群消息记录
  groupRecordsApi: `${MESSAGE}/api/session/group/records`,
  //群列表（监管入口）
  groupListApi: `${MESSAGE}/api/session/group/list`
}

// c2c模块
export const c2cModule = {
  // c2c配置列表
  c2cConfigListApi: `${C2C}/api/c2cSetting/list`,
  // 编辑/添加
  c2cConfigAddOrEditApi: `${C2C}/api/c2cSetting/addOrEdit`,
  // 删除
  c2cConfigDelApi: `${C2C}/api/c2cSetting/delete`,
  // 获取会话列表
  getSessionChatRecordApi: `${C2C}/api/c2cSetting/getSessionChatRecord`
}
//用户标签模块
export const userTagModule = {
  //用户标签列表
  queryUserTagListApi: `${USER}/api/user/label/listByUserId`,
  //新增标签
  addUserTagApi: `${USER}/api/user/label/add`,
  //删除标签
  delUserTagApi: `${USER}/api/user/label/del`
}

//用户模块
export const userInfoModule = {
  updateUserApi: `${USER}/api/user/edit`,
  listUserApi: `${USER}/api/user/list`,
  listUserAccountApi: `${USER}/api/user/listAccount`,
  editAccountApi: `${USER}/api/user/editAccount`,
  listUserBindApi: `${USER}/api/user/listByBind`,
  addUserApi: `${USER}/api/user/add`,
  detailUserApi: `${USER}/api/user/getUserById`,
  updateUserDeatilApi: `${USER}/api/user/editUser`,
  addUserBindApi: `${USER}/api/user/addBindUser`,
  getOrderListApi: `${USER}/api/user/front/order/list`
}

//用户-快捷回复分组模块
export const userFastGroupModule = {
  //分组列表
  fastGroupListApi: `${MESSAGE}/api/fastReplyGroup/list`,
  //分组新增
  fastGroupAddApi: `${MESSAGE}/api/fastReplyGroup/add`,
  //分组删除
  fastGroupDelApi: `${MESSAGE}/api/fastReplyGroup/del`,
  //分组更新
  fastGroupUpdateApi: `${MESSAGE}/api/fastReplyGroup/edit`
}

//用户-快捷回复模块
export const userFastReplyModule = {
  //新增
  fastReplyAddApi: `${MESSAGE}/api/fastReply/add`,
  //编辑
  fastReplyUpdateApi: `${MESSAGE}/api/fastReply/edit`,
  //删除
  fastReplyDelApi: `${MESSAGE}/api/fastReply/del`,
  //详情
  detailReplyApi: `${MESSAGE}/api/fastReply/detail`,
  //列表
  fastReplyListApi: `${MESSAGE}/api/fastReply/list`,
  //列表
  fastReplyAllListApi: `${MESSAGE}/api/fastReply/allList`,
  //常用快捷回复列表
  oftenFastReplyApi: `${MESSAGE}/api/fastReply/getOftenList`
}

//用户发送消息
export const messageModule = {
  //发送消息
  sendMessageApi: `${MESSAGE}/api/msg/cs/send`,

  //群发
  rcsSendAllApi: `${MESSAGE}/api/msg/rcs/sendAllThird`,

  //群发记录列表
  rcsSendListApi: `${MESSAGE}/api/msg/rcs/pageSend`,

  //群发记录列表
  thirdSessionDetailApi: `${MESSAGE}/api/msg/rcs/thirdSessionDetail`,
  //消息撤回
  withdrawApi: `${MESSAGE}/api/msg/cs/withdraw`
}

//敏感词
export const sensitiveKeyWordModule = {
  //敏感词列表
  sensitiveListApi: `${MESSAGE}/api/sensitiveKeyword/pageByCond`,
  //敏感词删除
  sensitiveDelApi: `${MESSAGE}/api/sensitiveKeyword/del`,
  //敏感词新增(批量)
  sensitiveAddApi: `${MESSAGE}/api/sensitiveKeyword/batchAdd`,
  //敏感词更新
  sensitiveUpdateApi: `${MESSAGE}/api/sensitiveKeyword/edit`
}

//坐席分组
export const customerGroupModule = {
  //分组添加
  customerGroupAddApi: `${USER}/api/employeeGroup/add`,
  //分组删除
  customerGroupDelApi: `${USER}/api/employeeGroup/del`,
  //分组编辑
  customerGroupEditApi: `${USER}/api/employeeGroup/edit`,
  //分组列表查询
  customerGroupListApi: `${USER}/api/employeeGroup/list`,
  customerGroupListAllApi: `${USER}/api/employeeGroup/alllist`
}
//菜单模块
export const menuModule = {
  //菜单添加 / 编辑
  menuAddApi: `${SYS}/api/menu`,
  //菜单删除
  menuDelApi: `${SYS}/api/menu`,
  //菜单列表
  menuListApi: `${SYS}/api/menu/list`,
  // 获取路由
  getRoutersApi: `${SYS}/api/menu/getRouters`
}
//租赁模块
export const tenantModule = {
  //租赁添加 / 编辑
  tenantAddUpdateApi: `${SYS}/api/tenant/addOrUpdate`,
  //租赁列表
  tenantListApi: `${SYS}/api/tenant/list`,
  //租赁删除
  tenantDelApi: `${SYS}/api/tenant/delete`,
  // 平台分配客服
  merchantEmployeeEditApi: `${USER}/api/merchant/merchantEmployeeEdit`,
}
//工单模块
export const orderModule = {
  //工单添加 / 编辑
  orderTypeEditAddApi: `${TICKETS}/api/tickets/type/editOrAdd`,
  //工单类别列表
  orderTypeListApi: `${TICKETS}/api/tickets/type/list`,
  //工单列表
  orderListApi: `${TICKETS}/api/tickets/order/list`,
  // 工单类别状态修改
  orderTypeStatusApi: `${TICKETS}/api/tickets/type/changeStatus`,
  // 提交/编辑工单
  orderEditAddApi: `${TICKETS}/api/tickets/order/editOrAdd`,
  //工单状态修改
  orderStatusApi: `${TICKETS}/api/tickets/order/changeLock`,
  // 工单详情状态处理
  orderAuditApi: `${TICKETS}/api/tickets/order/audit`,
  // 多选删除工单类别
  orderTypeDelIds: `${TICKETS}/api/tickets/type/deleteByIds`,
  // 第三方接口查询
  autoOrderApi: `${TICKETS}/api/tickets/order/autoOrder`,
  // 工单默认语言
  getDefaultLanguage: `${USER}/api/sysConfig/getDefaultLanguage`,
  // 更新工单默认语言
  updateDefaultLanguage: `${USER}/api/sysConfig/updateDefaultLanguage`,
  // 工单统计/api/tickets/order/type/statistics
  orderStatistics: `${TICKETS}/api/tickets/order/type/statistics`,

  ticketsOrder:  `${TICKETS}/api/tickets/order/listCount`,
  // 刷新es
  refreshEs:  `${TICKETS}/api/tickets/type/refreshEs`,
}
//平台分组
export const gameGroupModule = {
  //分组添加
  gameGroupAddApi: `${USER}/api/merchantGroup/add`,
  //分组删除
  gameGroupDelApi: `${USER}/api/merchantGroup/del`,
  //分组编辑
  gameGroupEditApi: `${USER}/api/merchantGroup/edit`,
  //分组列表查询
  gameGroupListApi: `${USER}/api/merchantGroup/list`
}

//坐席相关接口
export const customerModule = {
  //坐席列表
  customerListApi: `${USER}/api/employee/pageByCond`,
  customerListPhoneApi: `${USER}/api/employee/pageByCondPhone`,
  customerListApiByMerchantId: `${USER}/api/employee/pageByCondByMerchantId`,
  //添加员工
  customerAddApi: `${USER}/api/employee/add`,
  //删除坐席
  customerDelApi: `${USER}/api/employee/del`,
  //坐席详情
  customerDetailApi: `${USER}/api/employee/detail`,
  //坐席编辑
  customerEditApi: `${USER}/api/employee/edit`,
  //修改员工密码
  customerChangePasswordApi: `${USER}/api/employee/changePassword`
}

//登录相关模块
export const loginModule = {
  //登录
  loginInApi: `${USER}/api/login/doLogin`,
}

//当前登录的坐席信息
export const employeeModule = {
  //查询员工详情
  employeeInfoApi: `${USER}/api/login/getCurrentInfo`,

  //退出登录 (注销)
  employeeOutApi: `${USER}/api/login/logout`,

  //更改密码
  changePasswordApi: `${USER}/api/login/changePassword`,

  //更改客服状态
  changeStatusApi: `${USER}/api/login/changeCsStatus`,

  //更改客服状态
  changeListStatusApi: `${USER}/api/login/changeCsListStatus`,

  //更改客服偏好语言
  changeLanguageApi: `${USER}/api/login/changeLanguage`,

  //更改头像
  changeHeaderImgApi: `${USER}/api/login/changeHeaderImgUrl`,

  //更改通知铃声
  changeRingApi: `${USER}/api/employee/changeNoticeMusic`,

  //重置通知铃声
  resetRingApi: `${USER} /api/employee/resetNoticeMusic`,

  //客服偏好设置：开关客服机器人
  changeAiBotApi: `${USER}/api/employee/changeAiBot`
}

//AI智能
export const brainPower = {
  //常见问题设置
  newListApi: `${USER}/api/user/front/aiCustomer/problemList`,
  //问题分类
  dictTypeListApi: `${USER}/api/user/front/type/dictType`,
  //自动回复列表
  autoListApi: `${USER}/api/replay/list`,
  //自动回复删除
  autoDelApi: `${USER}/api/replay/del`,
  //自动回复添加
  autoAddApi: `${USER}/api/replay/add`,
  //自动回复编辑
  autoEditApi: `${USER}/api/replay/edit`,
  //自动回复刷新
  autoFlushApi: `${USER}/api/replay/refresh`,
  //查询推荐问题答案
  listByQuickReplay: `${USER}/api/replay/listByQuickReplay`
}
export const greeting = {
  //欢迎语列表
  greetingListApi: `${USER}/api/user/gameNotice/list`,
  //欢迎语添加
  greetingAddApi: `${USER}/api/user/gameNotice/add`,
  //欢迎语编辑
  greetingEditApi: `${USER}/api/user/gameNotice/edit`,
  //欢迎语删除
  greetingDelApi: `${USER}/api/user/gameNotice/del`
}

//应用接入
export const gameInModule = {
  addProblemApi: `${USER}/api/merchant/addProblem`,
  editProblemApi: `${USER}/api/merchant/editProblem`,
  listProblemApi: `${USER}/api/merchant/listProblem`,
  delProblemApi: `${USER}/api/merchant/delProblem`,
  updateProblemSwitchApi: `${USER}/api/merchant/updateProblemSwitch`,
  getProblemStatusApi: `${USER}/api/merchant/getProblemStatus`,

  //应用列表
  gameListApi: `${USER}/api/merchant/pageByCond`,
  //
  gameListByTenantApi: `${USER}/api/merchant/pageByCondByTenant`,
  // 平台工单开启
  gameUpdateTicketSwitchApi: `${USER}/api/merchant/updateTicketSwitch`,

  allMerChantForSet: `${USER}/api/merchant/allMerChantForSet`,
  //应用详情
  gameDetailApi: `${USER}/api/merchant/detail`,
  //应用新增
  gameAddApi: `${USER}/api/merchant/add`,
  //应用删除
  gameDelApi: `${USER}/api/merchant/del`,
  //编辑
  gameUpdateApi: `${USER}/api/merchant/edit`,

  // ---------------------------------------  应用分配规则 -------------------------------------

  //查看等级分配规则
  distributionLevelRuleListApi: `${USER}/api/merchant/distribution/getLevelRuleList`,
  //编辑等级分配规则
  distributionLevelRuleEditApi: `${USER}/api/merchant/distribution/editLevelRuleList`,
  //开关等级分配规则
  switchLevelRuleApi: `${USER}/api/merchant/distribution/switchLevelRule`,
  //查看用户分配规则
  pageUserRuleApi: `${USER}/api/merchant/distribution/pageUserRule`,

  userEmployeeCsTagInfoAdd: `${USER}/api/merchant/userEmployeeCsTagInfo/add`,
  userEmployeeCsTagInfoList: `${USER}/api/merchant/userEmployeeCsTagInfo/userEmployeeCsTagInfoList`,
  //删除用户分配规则
  getTagById: `${USER}/api/merchant/userEmployeeCsTagInfo/getById`,
  deleteById: `${USER}/api/merchant/userEmployeeCsTagInfo/delete`,
  delUserRuleApi: `${USER}/api/merchant/distribution/delUserRuleById`,
  //新增用户分配规则
  addUserRuleApi: `${USER}/api/merchant/distribution/addUserRule`,
  //开关用户分配规则
  switchUserRule: `${USER}/api/merchant/distribution/switchUserRule`,
  //标签开关
  switchTagRuleApi: `${USER}/api/merchant/distribution/switchTagRule`,
  // 标签列表状态修改
  tagUpdateStatusApi: `${USER}/api/merchant/userEmployeeCsTagInfo/updateStatus`,
  // 标签列表优先级修改
  tagUpdateSortApi: `${USER}/api/merchant/userEmployeeCsTagInfo/updateSort`,
  // 新增用户分配规则2
  addUserListRuleApi: `${USER}/api/merchant/distribution/addUserListRule`
}

/**
 * 首页
 *
 */
export const homeModule = {
  //今日数据概况
  todayDataApi: `${USER}/api/home/data/summary/nowDay`,
  //数据趋势
  trendApi: `${USER}/api/home/data/trend`,
  //数据排行
  rankingApi: `${USER}/api/home/data/ranking`,
  // 当日统计
  todayStatistics: `${MESSAGE}/api/session/cs/dashboard/snapshot`,
  // 实时统计
  realTimeStatistics: `${MESSAGE}/api/session/cs/dashboard/realtime`,
  // 在线客服列表
  liveAgentStatus: `${MESSAGE}/api/session/cs/dashboard/liveAgentStatus`,
  // 客服列表
  agentReportPage: `${MESSAGE}/api/session/cs/dashboard/agentReportPage`,
}

/**
 * 统计
 *
 */
export const statistics = {
  //今日数据概况
  totalStatistics: `${USER}/api/employeeCallStatistics/totalStatistics`,
  totalStatisticsUser: `${USER}/api/employeeCallStatistics/totalStatisticsUser`,
  totalStatisticsPhone: `${USER}/api/employeeCallStatistics/totalStatisticsPhone`,
  //数据趋势
  top5: `${USER}/api/employeeCallStatistics/top5`,
  //数据排行
  getTotalEachEmployee: `${USER}/api/employeeCallStatistics/getTotalEachEmployee`,
  getTotalEachEmployeeNew: `${USER}/api/employeeCallStatistics/getTotalEachEmployeeNew`,
  getTotalEachMouth: `${USER}/api/employeeCallStatistics/getTotalEachMouth`,
  getTotalEachDay: `${USER}/api/employeeCallStatistics/getTotalEachDay`,
  getTotal: `${USER}/info/getTotal`,
  exportInfo: `${USER}/info/export`,

  warnList: `${USER}/api/employeePhoneCount/warnList`,
  getWarnListDetails: `${USER}/api/employeePhoneCount/getWarnLogList`,
  getWarnSettingByGroupId: `${USER}/api/employeePhoneCount/getWarnSettingByGroupId/`,
  editOrAddWarnSetting: `${USER}/api/employeePhoneCount/editOrAddWarnSetting`,
  cancelWarnLog: `${USER}/api/employeePhoneCount/cancelWarnLog`,
  updateWarnLogRemark: `${USER}/api/employeePhoneCount/updateWarnLogRemark`,
  updateWarnLogTag: `${USER}/api/employeePhoneCount/updateWarnLogTag`,
  accessUser: `${MESSAGE}/api/msg/connectUser/access/user`,

  getHoliDayList: `${USER}/api/employeePhone/getHoliDayList`,
  updateHolidayStatus: `${USER}/api/employeePhone/updateHolidayStatus`,
  getHoliDayNum: `${USER}/api/employeePhone/getHoliDayNum`,

  getExportTask: `${USER}/api/employeePhone/getExportTask`,
  deleteTaskById: `${USER}/api/employeePhone/deleteTaskById/`,

  getPhoneTagListAll: `${USER}/api/dict/data/getPhoneTagListAll`,

  getPhoneHourStatistics: `${USER}/api/employeeCallStatistics/getPhoneHourStatistics`,
  totalStatisticsPhoneOverview: `${USER}/api/employeeCallStatistics/totalStatisticsPhoneOverview`,
  getListNew: `${USER}/api/employeePhoneCount/listNew`,
  getCallStatusOverview: `${USER}/api/employeeCallStatistics/getCallStatusOverview`,
  getPhoneTagStatistics: `${USER}/api/employeeCallStatistics/getPhoneTagStatistics`,
}

/**
 * 拨打日志
 *
 */
export const callLog = {
  //拨打
  pageByCond: `${USER}/api/callLog/pageByCond`,

  pageByCondUser: `${USER}/api/callLog/pageByCondUser`,

  //拨号
  callPhone: `${USER}/api/callLog/callPhone`,

  //获取当前客服的拨号状态
  getNowCallPhone: `${USER}/api/callLog/getNowCallPhone`,

  // 挂电话
  endCall: `${USER}/api/callLog/endCall`,
  
  //导出
  exportCallLog: `${USER}/api/callLog/export`,
}

/**
 * 发送短信
 *
 */
export const sendMsgApi = {
  //拨打
  phoneListApi: `${MSG}/api/sms/phoneList`,
  logPhoneList: `${MSG}/api/sms/logPhoneList`,
  phoneCountApi: `${MSG}/api/sms/phoneCount`,
  fileListApi: `${MSG}/api/sms/fileList`,
  tagList: `${MSG}/api/sms/tagList`,
  editTag: `${MSG}/api/sms/editTag`,
  delTag: `${MSG}/api/sms/delete`,
  tagPhoneList: `${MSG}/api/sms/tagPhoneList`,
  sendLogList: `${MSG}/api/sms/sendLogList`,
  phoneImport: `${MSG}/api/sms/import`,
  phoneImportForCount: `${MSG}/api/sms/phoneImportForCount`,
  sendMsg: `${MSG}/api/sms/sendMsg`,
  templatelist: `${MSG}/third/templatelist`,
  addToTag: `${MSG}/api/sms/addToTag`,
  deletePhone: `${MSG}/api/sms/deletePhone`,
  getPercent: `${MSG}/api/sms/getPercent`,
  // 导出短信
  addToExport: `${MSG}/api/sms/addToExport`,

  getWebsocketList: `${MSG}/api/sms/getWebsocketList`,
  updateSmsStatus: `${MSG}/api/sms/stopOrStart`,

  getUserPhone: `${MSG}/api/sms/getUserPhone`,
  addUserPhone: `${MSG}/api/sms/addUserPhone`,
  deleteUserPhone: `${MSG}/api/sms/deleteUserPhone`,
  startPhone: `${MSG}/api/sms/startPhone`
}

/**
 * 拨打日志
 *
 */
export const employeePhoneCount = {
  //拨打
  pageByCond: `${USER}/api/employeePhoneCount/list`
}

/**
 * 拨打日志
 *
 */
export const employeePhone = {
  //拨打
  pageByCond: `${USER}/api/employeePhone/list`,
  // 导入
  employeePhoneImport: `${USER}/api/employeePhone/import`,
  employeePhoneDistribute: `${USER}/api/employeePhone/distribute`,
  cleanPhoneNum: `${USER}/api/employeePhone/cleanPhoneNum`,
  //配置 /api/employeePhone/getHtml  /api/employeePhone/updateHtml
  employeeGetGuide: `${USER}/api/employeePhone/getHtml`,
  employeeUpdateGuide: `${USER}/api/employeePhone/updateHtml`,
  //清空
  deleteEmployPhone: `${USER}/api/employeePhone/deleteEmployPhone`,
  salesDataList: `${USER}/api/employeePhone/salesData/list`,
  salesDataAssign: `${USER}/api/employeePhone/salesData/assign`,
  
}

//------------------------------监管模块----------------------------------
export const checkModule = {
  //会话监管模块
  chatCheckApi: `${MESSAGE}/api/admin/check/sessionPageByChatRecord`,
  assessChatCheckApi: `${MESSAGE}/api/admin/check/vmSessionPageByChatRecord`,
  
  chatCheckApiCount: `${MESSAGE}/api/admin/check/sessionPageByChatRecordCount`,

  chatCheckChildApi: `${MESSAGE}/api/admin/check/sessionChildPageByChatRecord`,
  sessionChildPageByChatRecordCs: `${MESSAGE}/api/admin/check/sessionChildPageByChatRecordCs`,
  // 会话记录按聊天内容关键字（整词）搜索：监管后台 / 客服工作台
  sessionChildPageByPhrase: `${MESSAGE}/api/admin/check/sessionChildPageByPhrase`,
  sessionChildPageByPhraseCs: `${MESSAGE}/api/admin/check/sessionChildPageByPhraseCs`,
  // 超时会话
  chatCheckTimeoutApi: `${MESSAGE}/api/admin/check/sessionPageByTimeoutRecord`,
  //超时会话日志列表
  getTimeOutReadList: `${MESSAGE}/api/admin/check/read/getTimeOutList`,

  chatRateApi: `${MESSAGE}/api/admin/check/getRateRecord`,

  chatCheckNewApi: `${MESSAGE}/api/admin/check/sessionPageByChatRecordNew`,
  //敏感词监管
  sensitiveKeyWrodCheckApi: `${MESSAGE}/api/admin/check/sessionPageBySk`,
  //查询会话历史记录
  queryHistoryRecordApi: `${MESSAGE}/api/admin/check/getSessionChatRecord`,

  getCheckDataApi: `${MESSAGE}/api/admin/check/getCheckData`,

  addInMemberApi: `${MESSAGE}/api/admin/check/addInMember`,

  outSessionMemberApi: `${MESSAGE}/api/admin/check/outSessionMember`,

  exportCheckMerchantUserCount: `${MESSAGE}/api/admin/check/exportCheckMerchantUserCount`,
  // 修改状态
  handleStatus: `${MESSAGE}/api/admin/check/sessionChild/handleStatus`,
}

export const uploadModule = {
  // ---------------- 聊天记录 （可被删除） --------------------
  //上传图片
  uploadImgApi: `${MESSAGE}/api/upload/msg/image`,
  //上传视频
  uploadVideoApi: `${MESSAGE}/api/upload/msg/video`,
  //上传音频
  uploadAudioApi: `${MESSAGE}/api/upload/msg/audio`,
  //文件类型上传
  uploadFileApi: `${MESSAGE}/api/upload/msg/file`,
  //------------------- 用户头像之类的 -------------------------
  uploadSystemImgApi: `${USER}/api/upload/system/image`
}

/**
 * 偏好设置模块
 */
export const personSettingModule = {
  //获取个人快捷键详情
  getFastDetailApi: `${USER}/api/employee/Shortcuts/getShortcutsDetail`,

  //更新快捷键
  updateFastSetApi: `${USER}/api/employee/Shortcuts/updateShortcuts`
}

//----------------------------S3模块------------------------------------
export const S3Module = {
  /**
   * 获取上传的URL
   */
  getUploadUrlApi: `${USER}/api/s3/upload/getPreSignUrl`,
  uploadFile: `${USER}/api/s3/common/uploadFile`,
  /**
   * 下载
   */
  downUrlApi: `${USER}/api/s3/download/getPreSignUrl`
}

//-----------------------------翻译配置列表------------------------------
export const TranslateListModule = {
  //翻译配置列表
  tranlsteListApi: `${MESSAGE}/api/translation/config/list`,
  //更新翻译源
  translateUpdateApi: `${MESSAGE}/api/translation/config/edit`
}

//-----------------------------考核问题管理  -----------------------------

export const AssessmentModule = {
  //考核问题列表
  assessmentListApi: `${USER}/api/checkemployeequestion/list`,
  //更新考核问题
  assessmentAddOrUpdateApi: `${USER}/api/checkemployeequestion/editOrAdd`,
  // 删除考核问题
  assessmentDelete: `${USER}/api/checkemployeequestion/delete`

}

//-----------------------------考核结果看板  -----------------------------

export const CheckEmployeeStatModule = {
  //按日期+客服维度统计响应率/响应时长/准确率
  checkEmployeeStatListApi: `${MESSAGE}/api/checkEmployee/stat/list`
}


//----------------------------- 三方账号配置 -----------------------------
export const ThirdAccountModule = {
  //账号列表
  thirdAccountPageApi: `${USER}/api/third/app/account/page`,

  //账号详情
  thirdAccountDetailApi: `${USER}/api/third/app/account/detail`,

  //账号列表

  //账号编辑
  thirdAccountEditorApi: `${USER}/api/third/app/account/edit`,

  //账号删除
  thirdAccountDelApi: `${USER}/api/third/app/account/del`
}

//------------------------------- 三方平台好友 --------------------------------

export const ThirdPlatformModule = {
  //好友列表
  thirdPlatformFriendPageApi: `${USER}/api/third/app/friend/page`,

  //好友详情
  thirdPlatformFriendDetailApi: `${USER}/api/third/app/friend/detail`,

  //好友刷新
  thridPlatformFriendRefreshApi: `${USER}/api/third/app/friend/refresh`
}

//----------------------------- 角色 权限 -------------------------------------
export const RolePermissionsModule = {
  //新增角色
  addRoleApi: `${USER}/api/role/add`,

  //删除角色
  delRoleApi: `${USER}/api/role/del`,

  //更新角色
  updateRoleApi: `${USER}/api/role/edit`,

  //角色详情
  roleDetailApi: `${USER}/api/role/detail`,

  //角色分页查询
  rolePageApi: `${USER}/api/role/pageByCond`,
  //当前用户可分配角色
  roleListApi: `${USER}/api/role/listByCond`,

  //查询权限列表
  permissionlistApi: `${USER}/api/permission/list/all`,

  //根据id列表查询权限code
  roleIdsQueryApi: `${USER}/api/permission/batch/ids`
}
//----------------------------- 角色 管理 -------------------------------------
export const RoleManageModule = {
  //根据角色编号获取详细信息
  getDetailsByRoleId: `${SYS}/api/role`,

  //删除角色
  getRoleList: `${SYS}/api/role/list`,
  // 获取员工可分配的角色
  getCanRoleList: `${SYS}/api/role/canRoleList`,

  //新增/修改角色
  addAndModifyRole: `${SYS}/api/role`,

  //修改保存数据权限
  modifyDataScope: `${SYS}/api/role/dataScope`,

  //删除角色
  deleteSysRole: `${SYS}/api/role`,
  //修改角色状态
  changeStatus: `${SYS}/api/role/changeStatus`,
  //加载对应角色菜单列表树
  roleMenuTreeselect: `${SYS}/api/menu/roleMenuTreeselect`,
  //加载菜单列表树
  treeselect: `${SYS}/api/menu/treeselect`,
  treeselectNew: `${SYS}/api/menu/treeselectNew`,
  // 可分配角色
  roleRole: `${SYS}/api/role/roleRole`,
  // 获取分配角色列表
  roleRoleList: `${SYS}/api/role/roleRoleList`
}
//----------------------------系统配置------------------------------------
export const SystemConfigModule = {
  //获取配置列表
  getConfigListApi: `${USER}/api/sysConfig/getConfigList`,

  //更新会话自动结束
  updateSessionAutoEndApi: `${USER}/api/sysConfig/updateSessionAutoEnd`,
  updateSessionAutoCreateApi: `${USER}/api/sysConfig/updateSessionAutoCreate`,
  updateAutoStopAccountApi: `${USER}/api/sysConfig/updateAutoStopAccount`,
  updateTranslationOpen: `${USER}/api/sysConfig/updateTranslationOpen`,
  updateAiBotOpen: `${USER}/api/sysConfig/updateAiBotOpen`,
  updateTicketsOpen: `${USER}/api/sysConfig/updateTicketsOpen`,
  updateSessionCsCapacityApi: `${USER}/api/sysConfig/updateSessionCsCapacity`,
  updateSessionAutoEndClose: `${USER}/api/sysConfig/updateSessionAutoEndClose`,
  updateSessionCsAutoEnd: `${USER}/api/sysConfig/updateSessionCsAutoEnd`,

  //更新会话自动转接
  updateSessionAutoTransferApi: `${USER}/api/sysConfig/updateSessionAutTransfer`,

  //更新回复监管
  updateSessionCheckReplyApi: `${USER}/api/sysConfig/updateSessionCheckReply`,
   //查询自动提醒提示语配置
   listSessionAutoEndMessage: `${USER}/api/sysConfig/listSessionAutoEndMessage`,
   //新增或修改提示语配置
   updateSessionAutoEndMessage: `${USER}/api/sysConfig/updateSessionAutoEndMessage`,
   // 删除
   deleteSessionAutoEndMessage: `${USER}/api/sysConfig/deleteSessionAutoEndMessage/`,
}

export const CSModule = {
  //坐席列表分页
  csPageApi: `${USER}/api/employee/cs/page`,
  csPageCheckApi: `${USER}/api/employee/cs/pageCheck`,
  csPageCheckCountApi: `${USER}/api/employee/cs/pageCheckCount`,
  //坐席编辑
  csEditorApi: `${USER}/api/employee/cs/edit`,
  //强制下线
  kickCsApi: `${USER}/api/login/kickOut`,

  unlockCsApi: `${USER}/api/login/unlockCs`,
  enableApi: `${USER}/api/login/enable`,

  logListApi: `${USER}/api/user/loginLogList`
}

export const ReplyCheckModule = {
  //回复监管列表
  checkReplyListApi: `${MESSAGE}/api/admin/check/sessionPageByReplyCheck`
}

export const greetingConfigurationModule = {
  getByCurrentEmployeeIdApi: `${USER}/api/greetingConfiguration/getByCurrentEmployeeId`,
  insertApi: `${USER}/api/greetingConfiguration/insert`,
  updateApi: `${USER}/api/greetingConfiguration/update`
}
/**
 * 调用第三方接口的模块
 */
export const thirdApiModule = {
  getOrderListApi: `${USER}/api/user/front/order/list`
}

export const UserBlacklistModule = {
  //
  userBlacklistPageByCondApi: `${MESSAGE}/api/userBlacklist/pageByCond`,

  userBlacklistDeleteApi: `${MESSAGE}/api/userBlacklist/deleteById`,

  userBlacklistUpdateApi: `${MESSAGE}/api/userBlacklist/updateById`,

  userBlacklistInsertApi: `${MESSAGE}/api/userBlacklist/insert`,

  userBlacklistGetByIdApi: `${MESSAGE}/api/userBlacklist/getById`
}
export const AppealRecordModule = {
  updateStatusByIdApi: `${MESSAGE}/api/appealRecord/updateStatusById`,
  pageByCondApi: `${MESSAGE}/api/appealRecord/pageByCond`
}

//----------------------------- 字典管理-------------------------------------

export const DictionaryManagement = {
  //字典管理列表
  dictionaryListApi: `${USER}/api/dict/type/pageByCond`,
  //字典管理删除
  dictionaryDelApi: `${USER}/api/dict/type/del`,
  //字典管理添加
  dictionaryAddApi: `${USER}/api/dict/type/add`,
  //字典管理编辑
  dictionaryEditApi: `${USER}/api/dict/type/edit`,

  //字典管理列表
  dictionaryTheListApi: `${USER}/api/dict/data/pageByCond`,
  //字典管理列表添加
  dictionaryAddListApi: `${USER}/api/dict/data/add`,
  //字典管理列表编辑
  dictionaryEditListApi: `${USER}/api/dict/data/edit`,
  //字典管理列表删除
  dictionaryDelListApi: `${USER}/api/dict/data/del`
}
